module.exports = __webpack_public_path__ + "media/images/castlerock/faq2-8f9ce37f257d85d075d9ca9392a4c4d2.jpg";